import { render, staticRenderFns } from "./sch_bygz.vue?vue&type=template&id=9ad192e2&scoped=true"
import script from "./sch_bygz.vue?vue&type=script&lang=js"
export * from "./sch_bygz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad192e2",
  null
  
)

export default component.exports